import React, { useContext, useState } from 'react';
import { Icon, Form, Input, Layout, message, Typography, Divider } from 'antd';
import { get } from 'lodash';
import { Link } from 'react-router-dom';

import PdButton from 'components/pd-button';
import CompanyLogo from 'assets/images/logo.png';

import { AuthenticationContext } from 'contexts/authentication';

import './style.scss';

const { Content } = Layout;
const { Text } = Typography;

export function SignupPage({ form }) {
  const [loadingButton, seLoadingButton] = useState(false);
  const { getFieldDecorator } = form;

  const { login } = useContext(AuthenticationContext);

  async function handleSignup(payload) {
    try {
      seLoadingButton(true);
      await login({
        ...payload,
        email: payload.email.toLowerCase(),
      });
    } catch (err) {
      message.error(
        get(
          err,
          'response.data.message',
          "Can't connect to server, please check connection"
        )
      );
    } finally {
      seLoadingButton(false);
    }
  }

  function validateToPassword(rule, value, callback) {
    if (value && value !== form.getFieldValue("password")) {
      callback('Passwords does not match!');
    } else {
      callback();
    }
  }

  function handleSubmit(e) {
    e.preventDefault();
    form.validateFields((err, values) => {
      if (!err) {
        handleSignup(values);
      }
    });
  }

  return (
    <Content className="pd-login">
      <img src={CompanyLogo} alt="logo" width="400" />
      <Form onSubmit={handleSubmit} className="login-form">
        <Form.Item>
          {getFieldDecorator('firstname', {
            rules: [{ required: true, message: 'Please input your first name!' }],
          })(
            <Input
              prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />}
              placeholder="First Name"
            />
          )}
        </Form.Item>
        <Form.Item>
          {getFieldDecorator('lastname', {
            rules: [{ required: true, message: 'Please input your last name!' }],
          })(
            <Input
              prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />}
              placeholder="Last Name"
            />
          )}
        </Form.Item>
        <Form.Item>
          {getFieldDecorator('email', {
            rules: [{ required: true, message: 'Please input your email!' }],
          })(
            <Input
              prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />}
              placeholder="Email"
            />
          )}
        </Form.Item>
        <Form.Item>
          {getFieldDecorator('password', {
            rules: [{ required: true, message: 'Please input your Password!' }],
          })(
            <Input
              prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
              type="password"
              placeholder="Password"
            />
          )}
        </Form.Item>
        <Form.Item>
          {getFieldDecorator('confirm_password', {
            rules: [
              { 
                required: true, 
                message: 'Please input your Password!'
              },
              {
                validator: validateToPassword,
              },
            ],
          })(
            <Input
              prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
              type="password"
              placeholder="Confirm Password"
            />
          )}
        </Form.Item>
        <Form.Item>
          <PdButton
            className="login-form-button"
            loading={loadingButton}
            htmlType="submit">
            Sign Up
          </PdButton>
        </Form.Item>
      </Form>
      <Divider className="pd-login-divider" />
      <Text>
        Already have an account?{' '}
        <Link to="/login">Login</Link>
      </Text>
    </Content>
  );
}

export const SignupPageForm = Form.create({ name: 'signup' })(SignupPage);

export default { SignupPage };
